export default () => {
  if (typeof window !== 'undefined') {
    return !!window.BinanceChain
  }
  return true
}
